// ability.js
import { defineAbility } from '@casl/ability'

const ability = defineAbility(() => {
  // Define default abilities here if any
})

export default ability
